import { Pagination } from "src/app/core/utils/pagination.entity";
import { CompanyEntity } from "./company.entity";

export abstract class CompanyPagination extends Pagination<CompanyEntity[]> {}